import dayjs, { Dayjs } from 'dayjs';

/* Add this to disabledDate prop in DataPicker for disable previous date */

export const disablePrevDate = (current: Dayjs) => {
  return current && current < dayjs().add(-1, 'days');
};
